import React from 'react';
import I18n from 'i18n-js';

import { RCIcon, RCTooltip } from '@reverbdotcom/cadence/components';
import { MapPinIcon, TagIcon, LockIcon } from '@phosphor-icons/react';
import SanitizedRender from './sanitized_render';
import CoreLink from './core_link';
import { useHelpCenterArticleUrl } from '../url_helpers';


const ACCESS_POINTS_HELP_CENTER_ARTICLE_ID = '55691526668059';

export default function AccessPointPickupCallout({ showMapPinIcon = false }: { showMapPinIcon?: boolean }) {
  const learnMoreUrl = useHelpCenterArticleUrl(ACCESS_POINTS_HELP_CENTER_ARTICLE_ID);

  const details = (
    <div className="d-flex gap-2 fx-dir-col">
      <div>
        <RCIcon icon={<MapPinIcon />} size="inline" spacing="right" />
        {I18n.t('commons.accessPointCallout.shipToUpsStores')}
        {' '}
        <CoreLink to={learnMoreUrl} className="text-link">
          {I18n.t('commons.accessPointCallout.learnMore')}
        </CoreLink>
      </div>
      <div>
        <RCIcon icon={<TagIcon />} size="inline" spacing="right" />
        <SanitizedRender
          html={I18n.t('commons.accessPointCallout.saveOnShippingCosts',
            {
              tagOpen: '<strong>',
              tagClose: '</strong>',
            },
          )}
        />
      </div>
      <div>
        <RCIcon icon={<LockIcon />} size="inline" spacing="right" />
        {I18n.t('commons.accessPointCallout.keepGearSafe')}
      </div>
    </div>
  );

  return (
    <span className="fg-color-text-primary text-utility-350">
      {showMapPinIcon && <RCIcon icon={<MapPinIcon />} size="inline-prominent" spacing="right" />}
      <RCTooltip interactive type="underline" placement="bottom-start" text={details}>
        {I18n.t('commons.accessPointCallout.pickUpNearby')}
      </RCTooltip>
      {I18n.t('commons.accessPointCallout.saveOnShipping')}
    </span>
  );
}
